import { c as _c } from "react/compiler-runtime";
import Image from "next/image";
import type { ReactNode } from "react";
import Spinner from "@/components/utils/Spinner";
import type { TokenMetadata } from "@/components/nft-picker/NftPicker.types";
type TokenThumbnailProps = Readonly<{
  metadata?: TokenMetadata | undefined;
  decimalId: string;
  isLoading: boolean;
  hasError: boolean;
}>;
export function TokenThumbnail(t0) {
  const $ = _c(9);
  const {
    metadata,
    decimalId,
    isLoading,
    hasError
  } = t0;
  let content;
  if (metadata?.imageUrl) {
    const t1 = metadata.name ?? decimalId;
    let t2;
    if ($[0] !== metadata.imageUrl || $[1] !== t1) {
      t2 = <Image src={metadata.imageUrl} alt={t1} fill={true} sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw" className="tw-h-full tw-w-full tw-object-cover" />;
      $[0] = metadata.imageUrl;
      $[1] = t1;
      $[2] = t2;
    } else {
      t2 = $[2];
    }
    content = t2;
  } else {
    if (isLoading) {
      let t1;
      if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = <div aria-label="Loading thumbnail" aria-live="polite" className="tw-flex tw-h-full tw-w-full tw-items-center tw-justify-center"><Spinner /></div>;
        $[3] = t1;
      } else {
        t1 = $[3];
      }
      content = t1;
    } else {
      if (hasError) {
        let t1;
        if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
          t1 = <div aria-label="Failed to load thumbnail" className="tw-flex tw-h-full tw-w-full tw-flex-col tw-items-center tw-justify-center tw-text-[10px] tw-font-medium tw-leading-tight tw-text-red-300"><span>Load</span><span>Error</span></div>;
          $[4] = t1;
        } else {
          t1 = $[4];
        }
        content = t1;
      } else {
        let t1;
        if ($[5] !== decimalId) {
          t1 = <div className="tw-flex tw-h-full tw-w-full tw-items-center tw-justify-center tw-text-xs tw-text-iron-400">#{decimalId}</div>;
          $[5] = decimalId;
          $[6] = t1;
        } else {
          t1 = $[6];
        }
        content = t1;
      }
    }
  }
  let t1;
  if ($[7] !== content) {
    t1 = <div className="tw-relative tw-h-full tw-w-full tw-overflow-hidden tw-rounded-md tw-bg-iron-800">{content}</div>;
    $[7] = content;
    $[8] = t1;
  } else {
    t1 = $[8];
  }
  return t1;
}